import { devices } from "src/utils/styled/_variables.styled";
import styled from "styled-components";

export const FooterContainer = styled.section`

.footer__link-mobile {
	text-decoration: none;
}
`;
